// extracted by mini-css-extract-plugin
export var downArrow = "_bd-0";
export var label = "_bd-1";
export var treatmentCard = "_bd-3";
export var upArrow = "_bd-2";